module.exports = __webpack_public_path__ + "static/media/lightBlueCross.ff9219fc.svg";